export default "__VITE_ASSET__CcljEkOC__"